import LocalStorageService from 'external-services/local-storage-service/localStorage.service';
import { IAccount, IRole, NgLocalStorageKey } from 'shared-types/index';
import { IManagerState, Roles } from './types';
const NS = 'ManagerService'; // jshint ignore:line

class ManagerService {
  public accountLocked = false;
  public isManager = false;
  public isIncludedAdminRole = false; // This property to check whether roles includes VenueAdmin / AccountAdmin
  public storeLocally = true; // This property is only for diary
  private ManagerActionsService: any; // This property is only for diary

  public setup(storeLocally: boolean = false, ManagerActionsService: any = null): void {
    this.storeLocally = storeLocally;
    this.ManagerActionsService = ManagerActionsService;
    this.initValues();
  }

  public initValues(): IManagerState {
    let isManager = true;
    let accountLocked = false;
    const hasAccountCustomerAccess = false;

    if (this.storeLocally) this.isManager = isManager;

    if (
      LocalStorageService.get(NgLocalStorageKey.isManager) !== null &&
      LocalStorageService.get(NgLocalStorageKey.isManager) !== undefined
    ) {
      isManager = LocalStorageService.get(NgLocalStorageKey.isManager);
      if (this.storeLocally) this.isManager = isManager;
    }
    if (
      LocalStorageService.get(NgLocalStorageKey.accountLocked) !== null &&
      LocalStorageService.get(NgLocalStorageKey.accountLocked) !== undefined
    ) {
      accountLocked = LocalStorageService.get(NgLocalStorageKey.accountLocked);
      if (this.storeLocally) this.accountLocked = accountLocked;
    }

    return { isManager, accountLocked, hasAccountCustomerAccess };
  }

  public managerLock(cb?: () => void): void {
    const isManager = false;
    if (this.storeLocally) this.isManager = isManager;
    LocalStorageService.set(NgLocalStorageKey.isManager, isManager);
    if (cb) {
      cb();
    }
    this.ManagerActionsService.managerChange();
  }

  public managerUnlock(): void {
    const isManager = true;
    if (this.storeLocally) this.isManager = isManager;
    LocalStorageService.set(NgLocalStorageKey.isManager, isManager);
    this.ManagerActionsService.managerChange();
  }

  public setValuesFromAccountData(roles: IRole[]): IManagerState {
    const adminRoles = [
      Roles.VenueAdmin,
      Roles.AccountAdmin,
      Roles.AccountOwner,
      Roles.BookItAdmin,
    ];

    const role = roles[0].name as Roles;
    // let isManager = LocalStorageService.get(NgLocalStorageKey.isManager) !== false;
    const isManager = this.isManagerRole(roles);
    let accountLocked = false;

    if (this.storeLocally) this.accountLocked = accountLocked;

    if (this.storeLocally) this.isManager = isManager;

    const isAdminRole: boolean = roles.some((role) => (adminRoles as string[]).includes(role.name));
    if (isAdminRole) {
      this.isIncludedAdminRole = true;
    }

    if (role === Roles.VenueStaff) {
      // isManager = false;
      accountLocked = true;
      if (this.storeLocally) {
        // this.isManager = false;
        this.accountLocked = true;
      }
    }
    LocalStorageService.set(NgLocalStorageKey.isManager, isManager);
    LocalStorageService.set(NgLocalStorageKey.accountLocked, accountLocked);

    const hasAccountCustomerAccess = this.hasAccountCustomerAccess(roles);

    return { isManager, accountLocked, hasAccountCustomerAccess };
  }
  public hasAdminAccess(roles: IRole[]): boolean {
    const adminRoles = [
      Roles.VenueAdmin,
      Roles.Support,
      Roles.BookItAdmin,
      Roles.BookItStaff,
      Roles.AccountAdmin,
      Roles.AccountOwner,
      Roles.VenueManager,
      Roles.ABCUser,
      Roles.BookItAccountExporter,
    ];
    return roles.some((role) => (adminRoles as string[]).includes(role.name));
  }

  private hasAccountCustomerAccess(roles: IRole[]): boolean {
    const adminRoles = [
      Roles.VenueAdmin,
      Roles.Support,
      Roles.BookItAdmin,
      Roles.BookItStaff,
      Roles.AccountAdmin,
      Roles.AccountOwner,
      Roles.ABCUser,
      Roles.BookItAccountExporter,
    ];
    return roles.some((role) => (adminRoles as string[]).includes(role.name));
  }

  // same condition with hasAdminAccess function for now, might be different in the future - NBI-7865
  public isManagerRole(roles: IRole[]): boolean {
    const adminRoles = [
      Roles.VenueAdmin,
      Roles.Support,
      Roles.BookItAdmin,
      Roles.BookItStaff,
      Roles.AccountAdmin,
      Roles.AccountOwner,
      Roles.VenueManager,
      Roles.ABCUser,
      Roles.BookItAccountExporter,
    ];
    return roles.some((role) => (adminRoles as string[]).includes(role.name));
  }
}

const instance = new ManagerService();
export default instance as ManagerService;
